module.exports = __webpack_public_path__ + "img/div1.e05a9331.jpg";